import { render, staticRenderFns } from "./AcessoriosSelect.vue?vue&type=template&id=65f394d7&"
import script from "./AcessoriosSelect.vue?vue&type=script&lang=js&"
export * from "./AcessoriosSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports